import React, { useState, useEffect } from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import { EMPTY_OBJECT } from './AddTaskList'

function ImportMasking(props) {
    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [sqLDbList, setSqLDbList] = useState([])
    const [databaseId, setDatabaseId] = useState(-1)
    const [dataSourceSystemName, setDataSourceSystemName] = useState('')
    const [databaseName, setDatabaseName] = useState('')
    const [dataSources, setDataSources] = useState([])
    const [dimensions, setDimensions] = useState([])
    const [selectedDimension, setSelectedDimension] = useState('')
    const [jobFiles, setJobFiles] = useState([])
    const [selectedJobFileId, setSelectedJobFileId] = useState('')
    const [selectedJobFile, setSelectedJobFile] = useState('')
    const [filesWithinZip, setFilesWithinZip] = useState([])
    const [selectedFileWithinZip, setSelectedFileWithinZip] = useState('')
    const [columnsReadFromFile, setColumnsReadFromFile] = useState([])
    const [selectedSourceColumn, setSelectedSourceColumn] = useState('')
    const [selectedTargetColumn, setSelectedTargetColumn] = useState('')

    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 0)
            setSqLDbList(dBList)
        }

        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)
            setIsLoadingRequest(true)

            let getDataSources = props.getDataSources(props.taskData.databaseId)
            getDataSources.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setDataSources(json)
                setDataSourceSystemName(props.taskData.dataSourceSystemName)
                setDimensions([])
                
                let getDimensions = props.getDimensions(props.taskData.databaseId, props.taskData.dataSourceSystemName)
                getDimensions.then((resp) => { 
                    if (resp.status !== 200) {
                        throw new Error(resp)
                    } else {
                        return resp.json()
                    }
                }).then((json) => {
                    setIsLoadingRequest(false)

                    let processedResponse = []
                    for (let x = 0; x < json.length; x++) {
                        if (json[x]["typeOfDimension"] !== -1) {
                            processedResponse.push(json[x])
                        }
                    }

                    setDimensions(processedResponse)
                    setSelectedDimension(props.taskData.selectedDimensionSystemName)
                }).catch((ex) => {
                    console.error(ex)
                    setDataSources([])
                    setDimensions([])
                    setSelectedDimension('')
                    setIsLoadingRequest(false)
                })
            }).catch((ex) => {
                console.error(ex)
                setDataSourceSystemName('')
                setDataSources([])
                setDatabaseName('')
                setDimensions([])
                setDatabaseName('')
                setSelectedDimension('')
                setIsLoadingRequest(false)
                setSearchTerm('')
            })

            setDatabaseName(props.taskData.databaseName)
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setDataSourceSystemName('')
            setDataSources([])
            setDimensions([])
            setSelectedDimension('')
            setFilesWithinZip([])
            setSelectedFileWithinZip('')
        }

        if (props.jobFiles && props.jobFiles.length > 0) {
            setJobFiles(props.jobFiles)
            setSelectedJobFile(props.taskData.selectedZipFile)
            zipFileSelectedWithFiles(props.taskData.selectedZipFileId, props.jobFiles)
            setSelectedFileWithinZip(props.taskData.selectedFileWithinZip)
            fileWithinZipSelectedWithFiles(props.taskData.selectedFileWithinZip, props.jobFiles, props.taskData.selectedZipFile, props.taskData.selectedFileWithinZip).then(function() {
                setSelectedSourceColumn(props.taskData.selectedSourceColumn)
                setSelectedTargetColumn(props.taskData.selectedTargetColumn)
            })
        }
    }, [])

    useEffect(() => {
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)
            setIsLoadingRequest(true)

            let getDataSources = props.getDataSources(props.taskData.databaseId)
            getDataSources.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setDataSources(json)
                setDataSourceSystemName(props.taskData.dataSourceSystemName)
                setDimensions([])
                
                let getDimensions = props.getDimensions(props.taskData.databaseId, props.taskData.dataSourceSystemName)
                getDimensions.then((resp) => { 
                    if (resp.status !== 200) {
                        throw new Error(resp)
                    } else {
                        return resp.json()
                    }
                }).then((json) => {
                    setIsLoadingRequest(false)

                    let processedResponse = []
                    for (let x = 0; x < json.length; x++) {
                        if (json[x]["typeOfDimension"] !== -1) {
                            processedResponse.push(json[x])
                        }
                    }

                    setDimensions(processedResponse)
                    setSelectedDimension(props.taskData.selectedDimensionSystemName)
                }).catch((ex) => {
                    console.error(ex)
                    setDataSources([])
                    setDimensions([])
                    setSelectedDimension('')
                    setIsLoadingRequest(false)
                })
            }).catch((ex) => {
                console.error(ex)
                setDataSourceSystemName('')
                setDataSources([])
                setDatabaseName('')
                setDimensions([])
                setDatabaseName('')
                setSelectedDimension('')
                setIsLoadingRequest(false)
                setSearchTerm('')
            })

            setDatabaseName(props.taskData.databaseName)
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setDataSourceSystemName('')
            setDataSources([])
            setDimensions([])
            setSelectedDimension('')
            setFilesWithinZip([])
            setSelectedFileWithinZip('')
        }

        if (props.jobFiles && props.jobFiles.length > 0) {
            fileWithinZipSelectedWithFiles(props.taskData.selectedFileWithinZip, props.jobFiles, props.taskData.selectedZipFile, props.taskData.selectedFileWithinZip).then(function() {
                setSelectedSourceColumn(props.taskData.selectedSourceColumn)
                setSelectedTargetColumn(props.taskData.selectedTargetColumn)
            })
        }
    }, [
        props.taskData.databaseId,
        props.taskData.databaseName,
        props.taskData.dataSourceSystemName,
        props.taskData.selectedDimensionSystemName,
        props.taskData.selectedZipFileId,
        props.taskData.selectedZipFile,
        props.taskData.selectedFileWithinZip,
        props.taskData.selectedSourceColumn,
        props.taskData.selectedTargetColumn
    ])

    function handleDatabaseChange(event) {
        event.preventDefault()
        setDatabaseId(event.target.value)
        setIsLoadingRequest(true)

        let getDataSources = props.getDataSources(event.target.value)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            sqLDbList.forEach(db => {
                if (db.id === event.target.value) {
                    setDatabaseName(db.dBname)
                    fireOnSaveEvent(event.target.value, db.dBname, "", "", selectedJobFileId, selectedJobFile, selectedFileWithinZip, selectedSourceColumn, selectedTargetColumn)
                }
            })
            setDataSources(json)
            setIsLoadingRequest(false)
        }).catch((ex) => {
            console.error(ex)
            setIsLoadingRequest(false)
            setDataSourceSystemName('')
            setDatabaseName('')
        })
    }

    function handleDataSourceChange(event) {
        event.preventDefault()
        setDataSourceSystemName(event.target.value)
        setIsLoadingRequest(true)

        dataSources.forEach((ds) => {
            if (ds.key === event.target.value) {
                fireOnSaveEvent(databaseId, databaseName, event.target.value, "", selectedJobFileId, selectedJobFile, selectedFileWithinZip, selectedSourceColumn, selectedTargetColumn)
            }
        })

        let getDimensions = props.getDimensions(databaseId, event.target.value)
        getDimensions.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            setIsLoadingRequest(false)

            let processedResponse = []
            for (let x = 0; x < json.length; x++) {
                if (json[x]["typeOfDimension"] !== -1) {
                    processedResponse.push(json[x])
                }
            }

            setDimensions(processedResponse)
        }).catch((ex) => {
            console.error(ex)
            setDataSources([])
            setDimensions([])
            setSelectedDimension('')
            setIsLoadingRequest(false)
        })
    }

    function handleDimensionChange(event) {
        event.preventDefault()
        setSelectedDimension(event.target.value)
        setIsLoadingRequest(false)
        fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, event.target.value, selectedJobFileId, selectedJobFile, selectedFileWithinZip, selectedSourceColumn, selectedTargetColumn)
    }

    function handleZipFileChange(event) {
        event.preventDefault()
        zipFileSelected(event.target.value)
    }

    async function handleFileWithinZipChange(event) {
        event.preventDefault()
        fileWithinZipSelected(event.target.value)
        
        let lookup = null
        for (let x = 0; x < jobFiles.length; x++) {
            if (jobFiles[x]["identifier"] === event.target.value) {
                lookup = jobFiles[x]
            }
        }

        if (lookup) {
            setIsLoadingRequest(true)
            let readColumnsReq = await props.readColumnsFromZipEntry(lookup.name, lookup.url, lookup.containerName, lookup.blobName, event.target.value)
            let readColumnsResp = await readColumnsReq.json()
            setColumnsReadFromFile(readColumnsResp)
            fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, selectedDimension, selectedJobFileId, selectedJobFile, event.target.value, "", "")
        }

        setIsLoadingRequest(false)
    }

    function zipFileSelected(zipFileName) {
        setSelectedJobFileId(zipFileName)
        setSelectedJobFile('')

        let lookup = null
        for (let x = 0; x < jobFiles.length; x++) {
            if (jobFiles[x]["identifier"] === zipFileName) {
                lookup = jobFiles[x]
            }
        }

        if (lookup) {
            setIsLoadingRequest(true)
            setSelectedJobFile(lookup["name"])
            setFilesWithinZip(lookup["zipIndividualFiles"])
            setIsLoadingRequest(false)
            fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, selectedDimension, zipFileName, lookup["name"], "", "", "")
        } else {
            setSelectedJobFileId('')
            setSelectedJobFile('')
            setFilesWithinZip([])
            setSelectedFileWithinZip('')
        }
    }

    function zipFileSelectedWithFiles(zipFileName, files) {
        setSelectedJobFileId(zipFileName)
        setSelectedJobFile('')

        let lookup = null
        for (let x = 0; x < files.length; x++) {
            if (files[x]["identifier"] === zipFileName) {
                lookup = files[x]
            }
        }

        if (lookup) {
            setIsLoadingRequest(true)
            setSelectedJobFile(lookup["name"])
            setFilesWithinZip(lookup["zipIndividualFiles"])
            setIsLoadingRequest(false)
        } else {
            setFilesWithinZip([])
            setSelectedFileWithinZip('')
        }
    }

    async function fileWithinZipSelected(fileWithinZipName) {
        setSelectedFileWithinZip(fileWithinZipName)

        let lookup = null
        for (let x = 0; x < jobFiles.length; x++) {
            if (jobFiles[x]["name"] === selectedJobFile) {
                lookup = jobFiles[x]
            }
        }

        if (lookup) {
            setIsLoadingRequest(true)
            let readColumnsReq = await props.readColumnsFromZipEntry(lookup.name, lookup.url, lookup.containerName, lookup.blobName, fileWithinZipName)
            let readColumnsResp = await readColumnsReq.json()
            setColumnsReadFromFile(readColumnsResp)
            fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, selectedDimension, selectedJobFileId, selectedJobFile, fileWithinZipName, "", "")
        }

        setIsLoadingRequest(false)
    }

    async function fileWithinZipSelectedWithFiles(fileWithinZipName, files, selectedFile, nonZippedFile) {
        setSelectedFileWithinZip(fileWithinZipName)

        let lookup = null
        for (let x = 0; x < files.length; x++) {
            if (files[x]["name"] === selectedFile) {
                lookup = files[x]
            }
        }

        if (lookup === null) {
            for (let x = 0; x < files.length; x++) {
                if (files[x]["identifier"] === nonZippedFile) {
                    lookup = files[x]
                    setSelectedFileWithinZip(nonZippedFile)
                }
                if (files[x]["identifier"] === selectedFile) {
                    lookup = files[x]
                    setSelectedFileWithinZip(selectedFile)
                }
            }
        }

        if (lookup) {
            setIsLoadingRequest(true)
            let readColumnsReq = await props.readColumnsFromZipEntry(lookup.name, lookup.url, lookup.containerName, lookup.blobName, fileWithinZipName)
            let readColumnsResp = await readColumnsReq.json()
            setColumnsReadFromFile(readColumnsResp)
        }

        setIsLoadingRequest(false)
    }

    /**
     * fireOnSaveEvent
     * * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected database ID
     * @param {string} dbName - Selected name of the database
     * @param {string} dsSystemName - Data source system name from the selected database
     * @param {string} dimSystemName - Selected dimension system name
     * @param {string} zipFileId - Selected zip file unique ID
     * @param {string} zipFileName - Selected zip file for the current job
     * @param {string} fileWithinZip - Desktop database within zip file
     * @param {string} sourceColumn - Source column found within the selected file
     * @param {string} targetColumn - Target column found within the selected file
     */
    function fireOnSaveEvent(dbId, dbName, dsSystemName, dimSystemName, zipFileId, zipFileName, fileWithinZip, sourceColumn, targetColumn) {
        if (props.onSave) {
            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["databaseName"] = dbName
            copied["dataSourceSystemName"] = dsSystemName
            copied["selectedDimensionSystemName"] = dimSystemName
            copied["selectedZipFileId"] = zipFileId
            copied["selectedZipFile"] = zipFileName
            copied["selectedFileWithinZip"] = fileWithinZip
            copied["selectedSourceColumn"] = sourceColumn
            copied["selectedTargetColumn"] = targetColumn
            props.onSave(copied)
        }
    }

    return <Paper elevation={3} className="dbFunctionsPaper">
        <h3>Import Masking</h3>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-databse-label">Select Database</InputLabel>
            <Select
                labelId="select-databse-label"
                id="select-databse"
                label="Select Database"
                onChange={handleDatabaseChange}
                defaultValue={sqLDbList.length > 0 ? sqLDbList[0].id : -1}
                value={databaseId}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={-1}>Select Database</MenuItem>
                    { sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-data-source-label">Select Data Source</InputLabel>
            <Select
                labelId="select-data-source-label"
                id="select-data-source"
                label="Select Data Source"
                onChange={handleDataSourceChange}
                value={dataSourceSystemName}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select Data Source</MenuItem>
                    { dataSources.map((x) => x && <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>) }
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-dimension-label">Select Dimension</InputLabel>
            <Select
                labelId="select-dimension-label"
                id="select-dimension"
                label="Select Dimension"
                onChange={handleDimensionChange}
                value={selectedDimension}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select Dimension</MenuItem>
                    { dimensions.map((x) => x && <MenuItem key={x.systemName} value={x.systemName}>{x.alias}</MenuItem>) }
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-zip-file-label">Select Zip File</InputLabel>
            <Select
                labelId="select-zip-file-label"
                id="select-zip-file"
                label="Select Zip File"
                onChange={handleZipFileChange}
                value={selectedJobFileId}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select Zip File</MenuItem>
                    { jobFiles.map((x) => x && x.name.toLowerCase().includes(".zip") && <MenuItem key={x.identifier} value={x.identifier}>{x.name}</MenuItem>) }
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-file-within-zip-label">Select File Within Zip</InputLabel>
            <Select
                labelId="select-file-within-zip-label"
                id="select-file-within-zip"
                label="Select File Within Zip"
                onChange={handleFileWithinZipChange}
                value={selectedFileWithinZip}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select File Within Zip File</MenuItem>
                    { filesWithinZip.map((x) => x && <MenuItem key={x} value={x}>[{selectedJobFile}]{x}</MenuItem>) }
                    { jobFiles.map((x) => x && !x.name.toLowerCase().includes(".zip") && <MenuItem key={x.identifier} value={x.identifier}>{x.name}</MenuItem>) }
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-source-column-label">Select Item Name Column</InputLabel>
            <Select
                labelId="select-source-column-label"
                id="select-source-column"
                label="Select Item Name Column"
                onChange={(e) => {
                    e.preventDefault()
                    setSelectedSourceColumn(e.target.value)
                    fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, selectedDimension, selectedJobFileId, selectedJobFile, selectedFileWithinZip, e.target.value, selectedTargetColumn)
                }}
                value={selectedSourceColumn}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select Source Column</MenuItem>
                    { columnsReadFromFile.map((x) => x && <MenuItem key={x} value={x}>{x}</MenuItem>) }
            </Select>
        </FormControl>
        <FormControl className="field" fullWidth>
            <InputLabel id="select-target-column-label">Select Item Alias Column</InputLabel>
            <Select
                labelId="select-target-column-label"
                id="select-target-column"
                label="Select Item Alias Column"
                onChange={(e) => {
                    e.preventDefault()
                    setSelectedTargetColumn(e.target.value)
                    fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, selectedDimension, selectedJobFileId, selectedJobFile, selectedFileWithinZip, selectedSourceColumn, e.target.value)
                }}
                value={selectedTargetColumn}
                defaultValue={''}
                required
                fullWidth
                disabled={isLoadingRequest}>
                    <MenuItem value={''}>Select Target Column</MenuItem>
                    { columnsReadFromFile.map((x) => x && <MenuItem key={x} value={x}>{x}</MenuItem>) }
            </Select>
        </FormControl>
    </Paper>
}

export default ImportMasking